import React from 'react';
import { useAuth } from '../auth/useAuth';
import './Login.css';

const Login: React.FC = () => {
  const { login, isLoading } = useAuth();

  const handleLogin = async () => {
    try {
      await login();
    } catch (error) {
      console.error('Login error:', error);
    }
  };

  return (
    <div className="login-page">
      <div className="login-container">
        <div className="login-card">
          <div className="login-header">
            <h1 className="login-title">P&E Tools</h1>
            <p className="login-subtitle">Sign in to access the application</p>
          </div>
          <div className="login-content">
            <button
              className="btn btn-primary login-button"
              onClick={handleLogin}
              disabled={isLoading}
            >
              {isLoading ? 'Signing in...' : 'Sign in with Microsoft'}
            </button>
            <p className="login-info">
              This application uses Microsoft Azure AD for authentication.
              You will be redirected to Microsoft to sign in.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
